var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillingPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#EFF5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3411_10015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0711 12.9289C25.1823 11.0402 22.6711 10 20 10C17.3289 10 14.8177 11.0402 12.9289 12.9289C11.0402 14.8177 10 17.3289 10 20C10 22.6711 11.0402 25.1823 12.9289 27.0711C14.8177 28.9598 17.3289 30 20 30C22.6711 30 25.1823 28.9598 27.0711 27.0711C28.9598 25.1823 30 22.6711 30 20C30 17.3289 28.9598 14.8177 27.0711 12.9289ZM20 28.8281C15.1321 28.8281 11.1719 24.8679 11.1719 20C11.1719 15.1321 15.1321 11.1719 20 11.1719C24.8679 11.1719 28.8281 15.1321 28.8281 20C28.8281 24.8679 24.8679 28.8281 20 28.8281Z",
    fill: "#99A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6273 19.414H19.372C18.6569 19.414 18.0752 18.8323 18.0752 18.1172C18.0752 17.4021 18.657 16.8203 19.372 16.8203H21.8825C22.2061 16.8203 22.4684 16.558 22.4684 16.2344C22.4684 15.9108 22.2061 15.6484 21.8825 15.6484H20.5856V14.3516C20.5856 14.028 20.3232 13.7656 19.9996 13.7656C19.6761 13.7656 19.4137 14.028 19.4137 14.3516V15.6484H19.3721C18.0108 15.6484 16.9033 16.7559 16.9033 18.1172C16.9033 19.4784 18.0108 20.5859 19.3721 20.5859H20.6273C21.3424 20.5859 21.9241 21.1677 21.9241 21.8828C21.9241 22.5979 21.3424 23.1796 20.6273 23.1796H18.1169C17.7933 23.1796 17.5309 23.442 17.5309 23.7656C17.5309 24.0892 17.7933 24.3515 18.1169 24.3515H19.4137V25.6484C19.4137 25.972 19.6761 26.2344 19.9996 26.2344C20.3232 26.2344 20.5856 25.972 20.5856 25.6484V24.3515H20.6273C21.9885 24.3515 23.096 23.244 23.096 21.8828C23.096 20.5215 21.9885 19.414 20.6273 19.414Z",
    fill: "#99A4A3"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E9F1F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3411_10015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingPrice);
export default __webpack_public_path__ + "static/media/billingPrice.6375deed9c1271a95f3e93d743f15498.svg";
export { ForwardRef as ReactComponent };